import axios from "axios";
// Static import — adapter is available synchronously before any request fires
import { mockAdapter } from "../mocks/adapter";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000/api";
const USE_MOCK = process.env.REACT_APP_USE_MOCK === "true";

if (USE_MOCK) {
  console.info(
    "%c[mock] 🟢 Mock API active — all requests are intercepted locally",
    "color: #2563EB; font-weight: bold;"
  );
}

export const api = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
  // Inject mock adapter synchronously so the very first request is intercepted
  ...(USE_MOCK ? { adapter: mockAdapter as any } : {}),
});

// ── Auth token injection ──────────────────────────────────────────────────────
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// ── Global error handler ──────────────────────────────────────────────────────
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && !USE_MOCK) {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default api;
